// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --bw-pay-modal-width: 500px;
  --bw-pay-modal-wide: 820px;
  --bw-pay-backdrop: rgba(19, 35, 29, .44);
  --bw-pay-backdrop-soft: rgba(19, 35, 29, .34);
}

body {
  background: var(--bw-bg, #EFF0EC);
  color: var(--bw-text-primary, #13231D);
  font-family: var(--bw-font-family, "Sora", system-ui, -apple-system, "Segoe UI", sans-serif);
}

.bw-popup-demo {
  min-height: 100vh;
  padding: 32px 20px 72px;
}

.bw-popup-demo__top {
  width: min(100%, 1160px);
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.bw-popup-demo__back,
.bw-popup-demo__tab {
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  border-radius: var(--bw-radius-sm, 14px);
  border: 1px solid rgba(16, 25, 21, 0.1);
  background: var(--bw-surface-card-strong, rgba(247, 245, 241, 0.92));
  color: var(--bw-text-primary, #13231D);
  text-decoration: none;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
}

.bw-popup-demo__tab {
  background: transparent;
  border-color: rgba(130, 177, 148, 0.34);
}

.bw-popup-demo__tab.is-active,
.bw-popup-demo__tab:hover,
.bw-popup-demo__back:hover {
  background: rgba(130, 177, 148, 0.12);
  border-color: rgba(130, 177, 148, 0.44);
}

.bw-popup-demo__tabs {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.bw-popup-demo__stage {
  width: min(100%, 1160px);
  min-height: 720px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  border-radius: 32px;
  background: var(--bw-bg, #EFF0EC);
  border: 1px solid rgba(12, 36, 28, 0.08);
  box-shadow: var(--bw-shadow-card, 0 10px 30px rgba(0, 0, 0, 0.03));
}

.bw-popup-demo__fake-page {
  display: none;
}

.bw-popup-demo__fake-card {
  min-height: 260px;
  border-radius: var(--bw-card-radius, 24px);
  background: rgba(247, 245, 241, 0.88);
  border: 1px solid rgba(12, 36, 28, 0.08);
}

.bw-popup-demo__fake-main {
  display: grid;
  gap: 18px;
  align-content: start;
}

.bw-popup-demo__fake-banner {
  height: 320px;
}

.bw-popup-demo__fake-profile {
  height: 170px;
}

.bw-popup-demo__fake-side {
  height: 600px;
}

.bw-modal-backdrop {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: var(--bw-pay-backdrop, rgba(19, 35, 29, 0.44));
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 4;
  animation: bw-backdrop-in 0.24s ease;
}

.bw-modal-backdrop.is-soft {
  background: var(--bw-pay-backdrop-soft, rgba(19, 35, 29, 0.34));
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

@keyframes bw-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.bw-modal-card {
  width: min(100%, var(--bw-pay-modal-width));
  background: var(--bw-card-surface, #F7F5F1);
  border: 1px solid var(--bw-surface-card-border, rgba(12, 36, 28, 0.08));
  border-radius: var(--bw-card-radius, 24px);
  box-shadow: 0 22px 48px rgba(18, 34, 28, 0.14), 0 2px 10px rgba(18, 34, 28, 0.06);
  color: var(--bw-text-primary, #13231D);
  animation: bw-modal-in 0.28s ease;
}

.bw-modal-card--center {
  width: 100%;
  text-align: center;
  padding: 32px;
}

.bw-modal-card--status {
  text-align: center;
  padding: 32px;
}

.bw-modal-card--confirmation .bw-status-icon {
  width: 80px;
  height: 80px;
  border: none;
  background: none;
}

.bw-modal-card--confirmation .bw-status-icon svg {
  width: 80px !important;
  height: 80px !important;
}

@keyframes bw-modal-in {
  from {
    opacity: 0;
    transform: scale(0.94) translateY(12px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
.bw-status-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 20px;
  display: grid;
  place-items: center;
  color: var(--bw-primary-active, #5C826C);
}

.bw-status-icon svg {
  width: 70px !important;
  height: 70px !important;
}

.bw-status-icon--success {
  width: 80px;
  height: 80px;
  border: none;
  background: none;
  color: var(--bw-primary-active, #5C826C);
}

.bw-status-icon--success svg {
  width: 80px !important;
  height: 80px !important;
  fill: none;
}

.bw-status-icon--error {
  color: #DC2626;
}

.bw-status-icon--error svg {
  background-color: #FEE2E2;
  border: 5px solid #DC2626;
  border-radius: 50%;
}

.bw-status-icon--warning {
  color: var(--bw-gold-strong, #B88928);
}

.bw-status-icon--info {
  color: #598FD9;
}

.bw-status-icon--neutral {
  color: #64748b;
}

.bw-modal-eyebrow {
  margin: 0 0 8px;
  font-size: 12px;
  line-height: 1.2;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  font-weight: 800;
  color: var(--bw-primary-active, #5C826C);
}

.bw-modal-title {
  margin: 0;
  font-size: 32px;
  line-height: 1.04;
  letter-spacing: -0.045em;
  font-weight: 800;
  color: var(--bw-text-primary, #13231D);
}

.bw-modal-copy {
  margin: 12px auto 0;
  max-width: 38ch;
  font-size: 15px;
  line-height: 1.65;
  color: var(--bw-text-secondary, rgba(19, 35, 29, 0.68));
}

.bw-modal-actions {
  margin-top: 24px;
  display: grid;
  gap: 12px;
}

.bw-btn {
  appearance: none;
  min-height: 48px;
  padding: 0 20px;
  border-radius: var(--bw-control-radius, 16px);
  border: 1px solid transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1;
  font-weight: 800;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.bw-btn:hover {
  transform: translateY(-1px);
}

.bw-btn-primary {
  background: var(--bw-primary, #82B194);
  border-color: var(--bw-primary, #82B194);
  color: #fff;
  box-shadow: 0 12px 24px rgba(130, 177, 148, 0.22);
}

.bw-btn-primary:hover {
  background: var(--bw-primary-hover, #739F84);
  border-color: var(--bw-primary-hover, #739F84);
}

.bw-btn-secondary {
  background: transparent;
  border-color: rgba(130, 177, 148, 0.48);
  color: var(--bw-text-primary, #13231D);
}

.bw-btn-secondary:hover {
  background: rgba(130, 177, 148, 0.1);
}

.bw-btn-quiet {
  background: transparent;
  border-color: rgba(16, 25, 21, 0.1);
  color: var(--bw-text-secondary, rgba(19, 35, 29, 0.68));
}

.bw-btn-full {
  width: 100%;
}

.bw-payment-header {
  min-height: 72px;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid rgba(12, 36, 28, 0.08);
}

.bw-payment-header__title {
  margin: 0;
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: -0.035em;
  font-weight: 800;
}

.bw-payment-header__copy {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 1.45;
  color: var(--bw-text-secondary, rgba(19, 35, 29, 0.68));
}

.bw-payment-close {
  width: 38px;
  height: 38px;
  border-radius: var(--bw-radius-sm, 14px);
  border: 1px solid rgba(16, 25, 21, 0.1);
  background: transparent;
  color: rgba(19, 35, 29, 0.58);
  display: grid;
  place-items: center;
  cursor: pointer;
}

.bw-payment-close:hover {
  background: rgba(130, 177, 148, 0.1);
  color: var(--bw-text-primary, #13231D);
}

.bw-payment-body {
  padding: 26px;
  display: grid;
  grid-template-columns: 60% 40%;
  gap: 24px;
  align-items: start;
}

.bw-payment-provider-shell {
  min-height: 352px;
  padding: 22px;
  border-radius: var(--bw-radius-xl, 24px);
  background: var(--bw-input-surface, #FFFFFF);
  border: 1px solid rgba(16, 25, 21, 0.08);
  box-shadow: 0 10px 26px rgba(18, 34, 28, 0.05);
}

.bw-payment-iframe {
  width: 100%;
  min-height: 348px;
  border: 0;
  display: block;
  border-radius: var(--bw-radius-lg, 18px);
  background: #fff;
}

.bw-payment-summary {
  padding: 18px;
  border-radius: var(--bw-radius-xl, 24px);
  background: var(--bw-card-surface-soft, #F8F6F2);
  border: 1px solid rgba(12, 36, 28, 0.08);
}

.bw-payment-summary h3 {
  margin: 0 0 14px;
  font-size: 16px;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.bw-payment-summary dl {
  margin: 0;
  display: grid;
  gap: 10px;
}

.bw-payment-summary__row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(16, 25, 21, 0.08);
}

.bw-payment-summary__row:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.bw-payment-summary dt,
.bw-payment-summary dd {
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
}

.bw-payment-summary dt {
  color: var(--bw-text-secondary, rgba(19, 35, 29, 0.68));
  font-weight: 600;
}

.bw-payment-summary dd {
  text-align: right;
  color: var(--bw-text-primary, #13231D);
  font-weight: 800;
}

.bw-payment-secure {
  margin-top: 14px;
  display: flex;
  gap: 8px;
  align-items: flex-start;
  font-size: 12px;
  line-height: 1.45;
  color: var(--bw-text-secondary, rgba(19, 35, 29, 0.68));
}

.bw-payment-secure svg {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  stroke: var(--bw-primary-active, #5C826C);
  fill: none;
  stroke-width: 2;
}

/* Simulación visual de una pasarela externa. En producción se reemplaza por iframe o SDK. */
.provider-demo {
  width: min(100%, 520px);
  margin: 0 auto;
  padding: 0;
  color: #1f2937;
}

.provider-demo__label {
  margin: 0 0 12px;
  font-size: 13px;
  line-height: 1.2;
  font-weight: 700;
}

.provider-demo__input {
  width: 100%;
  min-height: 42px;
  padding: 0 14px;
  margin-bottom: 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}

.provider-demo__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.provider-demo__button {
  margin-top: 18px;
  width: 100%;
  min-height: 46px;
  border: 0;
  border-radius: 8px;
  background: #2563eb;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  display: grid;
  place-items: center;
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.24);
}

.bw-toast {
  position: absolute;
  left: 24px;
  bottom: 22px;
  width: min(520px, 100% - 48px);
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 16px 18px;
  border-radius: var(--bw-radius-lg, 18px);
  background: var(--bw-card-surface, #F7F5F1);
  border: 1px solid rgba(130, 177, 148, 0.28);
  box-shadow: 0 18px 34px rgba(18, 34, 28, 0.12);
  z-index: 7;
}

.bw-message {
  position: fixed;
  bottom: 22px;
  left: 24px;
  max-width: 520px;
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 16px 18px;
  border-radius: var(--bw-radius-lg, 12px);
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.08);
  z-index: 1400;
}

.bw-message__icon {
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  display: inline-grid;
  place-items: center;
  background: rgba(130, 177, 148, 0.18);
  color: var(--bw-primary-active, #5C826C);
  border-radius: var(--bw-radius-pill, 999px);
  border: 1px solid rgba(130, 177, 148, 0.14);
}

.bw-message__content {
  display: block;
  min-width: 0;
  padding-top: 1px;
}

.bw-message__title {
  display: block;
  font-size: 14px;
  line-height: 1.25;
  color: var(--bw-text-primary, #13231D);
}

.bw-message__message {
  display: block;
  margin-top: 6px;
  font-size: 13px;
  line-height: 1.45;
  color: var(--bw-text-secondary, rgba(19, 35, 29, 0.68));
}

.bw-message__close {
  margin-left: auto;
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  color: rgba(19, 35, 29, 0.46);
  cursor: pointer;
  display: grid;
  place-items: center;
  padding: 0;
}

.bw-toast__icon {
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  margin-top: 0;
  border-radius: var(--bw-radius-pill, 999px);
  display: inline-grid;
  place-items: center;
  background: rgba(130, 177, 148, 0.18);
  color: var(--bw-primary-active, #5C826C);
}

.bw-toast__icon svg {
  display: block;
  width: 17px;
  height: 17px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2.3;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.bw-toast__content {
  display: block;
  min-width: 0;
  padding-top: 1px;
}

.bw-toast strong,
.bw-toast__title {
  display: block;
  font-size: 14px;
  line-height: 1.25;
  color: var(--bw-text-primary, #13231D);
}

.bw-toast__message {
  display: block;
  margin-top: 3px;
  font-size: 13px;
  line-height: 1.45;
  color: var(--bw-text-secondary, rgba(19, 35, 29, 0.68));
}

.bw-toast__title {
  display: block;
  border: 1px solid rgba(130, 177, 148, 0.14);
  line-height: 1.25;
  color: var(--bw-text-primary, #13231D);
  font-weight: 700;
}

.bw-toast__close {
  margin-left: auto;
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  color: rgba(19, 35, 29, 0.46);
  cursor: pointer;
  display: grid;
  place-items: center;
  padding: 0;
}

.bw-popup-state {
  display: none;
}

.bw-popup-state.is-active {
  display: block;
}

@media (max-width: 900px) {
  .bw-popup-demo__stage {
    min-height: 760px;
  }
  .bw-popup-demo__fake-page {
    grid-template-columns: 1fr;
    padding: 24px;
  }
  .bw-popup-demo__fake-side {
    display: none;
  }
  .bw-payment-body {
    grid-template-columns: 1fr;
  }
  .bw-payment-summary {
    order: -1;
  }
  .bw-modal-card--wide {
    max-height: calc(100vh - 48px);
    max-height: calc(100dvh - 48px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 620px) {
  .bw-popup-demo {
    padding: 20px 14px 56px;
  }
  .bw-popup-demo__stage {
    border-radius: 24px;
    min-height: 760px;
  }
  .bw-modal-backdrop {
    padding: 16px;
    align-items: center;
  }
  .bw-modal-card {
    padding: 24px 20px;
    border-radius: 22px;
  }
  .bw-modal-card--wide {
    padding: 0;
    max-height: calc(100vh - 32px);
    max-height: calc(100dvh - 32px);
    border-radius: 18px;
  }
  .bw-modal-title {
    font-size: 28px;
  }
  .bw-payment-body {
    padding: 18px;
    gap: 16px;
  }
  .bw-payment-header {
    padding: 18px;
  }
  .bw-payment-provider-shell {
    padding: 16px;
  }
  .bw-payment-iframe {
    min-height: 400px;
  }
  .bw-toast {
    left: 16px;
    bottom: 16px;
    width: calc(100% - 32px);
  }
  .provider-demo__grid {
    grid-template-columns: 1fr;
  }
}
/* =========================================================
   Estado adicional — Datos de reserva antes del pago
   Reemplaza la acción positiva roja por Primary Bodhiwell y
   ordena la información en header / cuerpo / footer.
========================================================= */
.bw-modal-card--booking {
  width: min(100%, 960px);
  max-height: min(90vh, 90dvh);
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.bw-booking-header {
  padding: 24px 32px 16px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  border-bottom: 1px solid rgba(12, 36, 28, 0.08);
}

.bw-booking-title {
  margin: 0;
  font-size: 26px;
  line-height: 1.12;
  letter-spacing: -0.04em;
  font-weight: 800;
  color: var(--bw-text-primary, #13231D);
}

.bw-booking-copy {
  margin: 8px 0 0;
  max-width: none;
  font-size: 13px;
  line-height: 1.45;
  color: var(--bw-text-secondary, rgba(19, 35, 29, 0.68));
}

.bw-booking-body {
  padding: 20px 32px 18px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.bw-booking-panel {
  display: grid;
  align-content: start;
  gap: 18px;
}

.bw-field {
  display: grid;
  gap: 8px;
}

.bw-field span,
.bw-upload-label {
  font-size: 13px;
  line-height: 1.35;
  font-weight: 600;
  color: var(--bw-text-primary, #13231D);
}

.bw-field input,
.bw-field textarea {
  width: 100%;
  border: 1px solid rgba(16, 25, 21, 0.14);
  border-radius: var(--bw-control-radius, 16px);
  background: var(--bw-input-surface, #FFFFFF);
  color: var(--bw-text-primary, #13231D);
  font-family: inherit;
  font-size: 15px;
  line-height: 1.45;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.bw-field input {
  min-height: 50px;
  padding: 0 16px;
}

.bw-field textarea {
  min-height: 118px;
  padding: 14px 16px;
  resize: vertical;
}

.bw-field input::placeholder,
.bw-field textarea::placeholder {
  color: rgba(19, 35, 29, 0.36);
}

.bw-field input:focus,
.bw-field textarea:focus {
  border-color: rgba(130, 177, 148, 0.7);
  box-shadow: 0 0 0 4px rgba(130, 177, 148, 0.14);
}

.bw-booking-note {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 46px;
  padding: 10px 14px;
  border-radius: var(--bw-control-radius, 16px);
  background: rgba(130, 177, 148, 0.12);
  color: var(--bw-primary-active, #5C826C);
  font-size: 13px;
  line-height: 1.45;
}

.bw-booking-note svg {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.bw-booking-note strong {
  font-weight: 800;
}

.bw-upload-card {
  width: 100%;
  min-height: 148px;
  border-radius: var(--bw-radius-xl, 24px);
  border: 1.5px dashed rgba(92, 130, 108, 0.38);
  background: var(--bw-card-surface-soft, #F8F6F2);
  color: var(--bw-text-primary, #13231D);
  font-family: inherit;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 10px;
  padding: 24px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.bw-upload-card:hover {
  background: rgba(130, 177, 148, 0.1);
  border-color: rgba(92, 130, 108, 0.62);
  transform: translateY(-1px);
}

.bw-upload-card__icon {
  width: 40px;
  height: 40px;
  border-radius: var(--bw-radius-pill, 999px);
  display: grid;
  place-items: center;
  background: rgba(130, 177, 148, 0.16);
  color: var(--bw-primary-active, #5C826C);
}

.bw-upload-card__icon svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.bw-upload-card strong {
  color: var(--bw-primary-active, #5C826C);
  font-weight: 800;
}

.bw-upload-card small {
  font-size: 12px;
  line-height: 1.3;
  color: var(--bw-text-secondary, rgba(19, 35, 29, 0.68));
}

.bw-booking-footer {
  padding: 18px 32px 26px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 22px;
  border-top: 1px solid rgba(12, 36, 28, 0.08);
}

.bw-booking-price {
  min-width: 136px;
  min-height: 58px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  border-radius: var(--bw-control-radius, 16px);
  background: rgba(130, 177, 148, 0.12);
  color: var(--bw-text-primary, #13231D);
}

.bw-booking-price__icon {
  width: 32px;
  height: 32px;
  border-radius: var(--bw-radius-pill, 999px);
  display: grid;
  place-items: center;
  background: rgba(130, 177, 148, 0.22);
  color: var(--bw-primary-active, #5C826C);
  font-weight: 800;
}

.bw-booking-price small {
  display: block;
  margin-bottom: 2px;
  font-size: 11px;
  line-height: 1;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--bw-text-secondary, rgba(19, 35, 29, 0.68));
  font-weight: 800;
}

.bw-booking-price strong {
  display: block;
  font-size: 18px;
  line-height: 1.1;
  letter-spacing: -0.02em;
}

.bw-switch-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  font-size: 14px;
  line-height: 1.35;
  color: var(--bw-text-primary, #13231D);
  cursor: pointer;
}

.bw-switch-row input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.bw-switch {
  width: 42px;
  height: 24px;
  border-radius: var(--bw-radius-pill, 999px);
  background: rgba(19, 35, 29, 0.2);
  position: relative;
  flex: 0 0 auto;
  transition: background-color 0.2s ease;
}

.bw-switch::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 6px rgba(18, 34, 28, 0.18);
  transition: transform 0.2s ease;
}

.bw-switch-row input:checked + .bw-switch {
  background: var(--bw-primary, #82B194);
}

.bw-switch-row input:checked + .bw-switch::after {
  transform: translateX(18px);
}

.bw-booking-cta {
  min-width: 220px;
}

@media (max-width: 900px) {
  .bw-modal-card--booking {
    max-height: none;
    height: auto;
    overflow: visible;
  }
  .bw-booking-body {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .bw-booking-footer {
    grid-template-columns: 1fr;
    align-items: stretch;
  }
  .bw-booking-cta {
    width: 100%;
    min-width: 0;
  }
}
@media (max-width: 620px) {
  .bw-booking-header {
    padding: 22px 20px 18px;
  }
  .bw-booking-title {
    font-size: 24px;
  }
  .bw-booking-body {
    padding: 20px;
  }
  .bw-booking-footer {
    padding: 18px 20px 22px;
  }
}
/* Fix autofill blue background */
.bw-field input:-webkit-autofill,
.bw-field input:-webkit-autofill:hover,
.bw-field input:-webkit-autofill:focus,
.bw-field input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #FFFFFF inset !important;
  -webkit-text-fill-color: var(--bw-text-primary, #13231D) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/booking-popups.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,2BAAA;EACA,0BAAA;EACA,wCAAA;EACA,6CAAA;AAEF;;AACA;EACE,iCAAA;EACA,sCAAA;EACA,4FAAA;AAEF;;AACA;EACE,iBAAA;EACA,uBAAA;AAEF;;AACA;EACE,wBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AAEF;;AACA;;EAEE,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,wCAAA;EACA,uCAAA;EACA,oEAAA;EACA,sCAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAEF;;AACA;EACE,uBAAA;EACA,uCAAA;AAEF;;AACA;;;EAGE,qCAAA;EACA,uCAAA;AAEF;;AACA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAEF;;AACA;EACE,wBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iCAAA;EACA,wCAAA;EACA,kEAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,iBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;AAEF;;AACA;EACE,aAAA;EACA,SAAA;EACA,oBAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,0DAAA;EACA,0BAAA;EACA,kCAAA;EACA,UAAA;EACA,oCAAA;AAEF;;AACA;EACE,+DAAA;EACA,0BAAA;EACA,kCAAA;AAEF;;AACA;EACE;IACE,UAAA;EAEF;EACA;IACE,UAAA;EACF;AACF;AAEA;EACE,2CAAA;EACA,2CAAA;EACA,uEAAA;EACA,0CAAA;EACA,iFAAA;EACA,sCAAA;EACA,iCAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;AAAF;;AAGA;EACE,kBAAA;EACA,aAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAAF;;AAGA;EACE,sBAAA;EACA,uBAAA;AAAF;;AAGA;EACE;IACE,UAAA;IACA,uCAAA;EAAF;EAGA;IACE,UAAA;IACA,iCAAA;EADF;AACF;AAIA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;AAFF;;AAKA;EACE,sBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;AAFF;;AAKA;EACE,sBAAA;EACA,uBAAA;EACA,UAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,qCAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAMA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,wCAAA;AAHF;;AAMA;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,sCAAA;AAHF;;AAMA;EACE,mBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,uDAAA;AAHF;;AAMA;EACE,gBAAA;EACA,aAAA;EACA,SAAA;AAHF;;AAMA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;EACA,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,yGAAA;AAHF;;AAMA;EACE,2BAAA;AAHF;;AAMA;EACE,sCAAA;EACA,wCAAA;EACA,WAAA;EACA,iDAAA;AAHF;;AAMA;EACE,4CAAA;EACA,8CAAA;AAHF;;AAMA;EACE,uBAAA;EACA,uCAAA;EACA,sCAAA;AAHF;;AAMA;EACE,oCAAA;AAHF;;AAMA;EACE,uBAAA;EACA,mCAAA;EACA,uDAAA;AAHF;;AAMA;EACE,WAAA;AAHF;;AAMA;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,+CAAA;AAHF;;AAMA;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,uDAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,uCAAA;EACA,uBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAHF;;AAMA;EACE,oCAAA;EACA,sCAAA;AAHF;;AAMA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,aAAA;EACA,wCAAA;EACA,4CAAA;EACA,wCAAA;EACA,8CAAA;AAHF;;AAMA;EACE,WAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;EACA,wCAAA;EACA,gBAAA;AAHF;;AAMA;EACE,aAAA;EACA,wCAAA;EACA,gDAAA;EACA,wCAAA;AAHF;;AAMA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,SAAA;EACA,aAAA;EACA,SAAA;AAHF;;AAMA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;EACA,+CAAA;AAHF;;AAMA;EACE,iBAAA;EACA,gBAAA;AAHF;;AAMA;;EAEE,SAAA;EACA,eAAA;EACA,iBAAA;AAHF;;AAMA;EACE,uDAAA;EACA,gBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,sCAAA;EACA,gBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,aAAA;EACA,QAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,uDAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,yCAAA;EACA,UAAA;EACA,eAAA;AAHF;;AAMA,4FAAA;AACA;EACE,uBAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;AAHF;;AAMA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAHF;;AAMA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAHF;;AAMA;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,8CAAA;AAHF;;AAMA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,wCAAA;EACA,2CAAA;EACA,2CAAA;EACA,8CAAA;EACA,UAAA;AAHF;;AAMA;EACE,eAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,wCAAA;EACA,mBAAA;EACA,qCAAA;EACA,2CAAA;EACA,aAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,qCAAA;EACA,wCAAA;EACA,2CAAA;EACA,2CAAA;AAHF;;AAMA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;AAHF;;AAMA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;AAHF;;AAMA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,uDAAA;AAHF;;AAMA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,2CAAA;EACA,oBAAA;EACA,mBAAA;EACA,qCAAA;EACA,wCAAA;AAHF;;AAMA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,UAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AAHF;;AAMA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;AAHF;;AAMA;;EAEE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;AAHF;;AAMA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,uDAAA;AAHF;;AAMA;EACE,cAAA;EACA,2CAAA;EACA,iBAAA;EACA,sCAAA;EACA,gBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE;IACE,iBAAA;EAHF;EAMA;IACE,0BAAA;IACA,aAAA;EAJF;EAOA;IACE,aAAA;EALF;EAQA;IACE,0BAAA;EANF;EASA;IACE,SAAA;EAPF;EAUA;IACE,8BAAA;IACA,+BAAA;IACA,gBAAA;IACA,iCAAA;EARF;AACF;AAWA;EACE;IACE,uBAAA;EATF;EAYA;IACE,mBAAA;IACA,iBAAA;EAVF;EAaA;IACE,aAAA;IACA,mBAAA;EAXF;EAcA;IACE,kBAAA;IACA,mBAAA;EAZF;EAeA;IACE,UAAA;IACA,8BAAA;IACA,+BAAA;IACA,mBAAA;EAbF;EAgBA;IACE,eAAA;EAdF;EAiBA;IACE,aAAA;IACA,SAAA;EAfF;EAkBA;IACE,aAAA;EAhBF;EAmBA;IACE,aAAA;EAjBF;EAoBA;IACE,iBAAA;EAlBF;EAqBA;IACE,UAAA;IACA,YAAA;IACA,wBAAA;EAnBF;EAsBA;IACE,0BAAA;EApBF;AACF;AAuBA;;;;2DAAA;AAMA;EACE,uBAAA;EACA,4BAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAtBF;;AAyBA;EACE,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,+CAAA;AAtBF;;AAyBA;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,sCAAA;AAtBF;;AAyBA;EACE,eAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,uDAAA;AAtBF;;AAyBA;EACE,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,oBAAA;EACA,SAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,QAAA;AAtBF;;AAyBA;;EAEE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,sCAAA;AAtBF;;AAyBA;;EAEE,WAAA;EACA,wCAAA;EACA,6CAAA;EACA,4CAAA;EACA,sCAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,wDAAA;AAtBF;;AAyBA;EACE,gBAAA;EACA,eAAA;AAtBF;;AAyBA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;AAtBF;;AAyBA;;EAEE,6BAAA;AAtBF;;AAyBA;;EAEE,sCAAA;EACA,+CAAA;AAtBF;;AAyBA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;EACA,qCAAA;EACA,wCAAA;EACA,eAAA;EACA,iBAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AAtBF;;AAyBA;EACE,gBAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,iBAAA;EACA,wCAAA;EACA,6CAAA;EACA,gDAAA;EACA,sCAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,mFAAA;AAtBF;;AAyBA;EACE,oCAAA;EACA,sCAAA;EACA,2BAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,YAAA;EACA,2CAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,wCAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AAtBF;;AAyBA;EACE,wCAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,eAAA;EACA,gBAAA;EACA,uDAAA;AAtBF;;AAyBA;EACE,uBAAA;EACA,aAAA;EACA,+CAAA;EACA,mBAAA;EACA,SAAA;EACA,4CAAA;AAtBF;;AAyBA;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,6CAAA;EACA,qCAAA;EACA,sCAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,YAAA;EACA,2CAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,wCAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,uDAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,eAAA;AAtBF;;AAyBA;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,YAAA;EACA,2CAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,sCAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;EACA,+BAAA;AAtBF;;AAyBA;EACE,sCAAA;AAtBF;;AAyBA;EACE,2BAAA;AAtBF;;AAyBA;EACE,gBAAA;AAtBF;;AAyBA;EACE;IACE,gBAAA;IACA,YAAA;IACA,iBAAA;EAtBF;EAyBA;IACE,0BAAA;IACA,SAAA;EAvBF;EA0BA;IACE,0BAAA;IACA,oBAAA;EAxBF;EA2BA;IACE,WAAA;IACA,YAAA;EAzBF;AACF;AA4BA;EACE;IACE,uBAAA;EA1BF;EA6BA;IACE,eAAA;EA3BF;EA8BA;IACE,aAAA;EA5BF;EA+BA;IACE,uBAAA;EA7BF;AACF;AAiCA,iCAAA;AACA;;;;EAIE,uDAAA;EACA,mEAAA;AA/BF","sourcesContent":[":root {\r\n  --bw-pay-modal-width: 500px;\r\n  --bw-pay-modal-wide: 820px;\r\n  --bw-pay-backdrop: rgba(19, 35, 29, .44);\r\n  --bw-pay-backdrop-soft: rgba(19, 35, 29, .34);\r\n}\r\n\r\nbody {\r\n  background: var(--bw-bg, #EFF0EC);\r\n  color: var(--bw-text-primary, #13231D);\r\n  font-family: var(--bw-font-family, \"Sora\", system-ui, -apple-system, \"Segoe UI\", sans-serif);\r\n}\r\n\r\n.bw-popup-demo {\r\n  min-height: 100vh;\r\n  padding: 32px 20px 72px;\r\n}\r\n\r\n.bw-popup-demo__top {\r\n  width: min(100%, 1160px);\r\n  margin: 0 auto 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.bw-popup-demo__back,\r\n.bw-popup-demo__tab {\r\n  min-height: 40px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0 14px;\r\n  border-radius: var(--bw-radius-sm, 14px);\r\n  border: 1px solid rgba(16, 25, 21, .10);\r\n  background: var(--bw-surface-card-strong, rgba(247, 245, 241, .92));\r\n  color: var(--bw-text-primary, #13231D);\r\n  text-decoration: none;\r\n  font-size: 13px;\r\n  font-weight: 800;\r\n  cursor: pointer;\r\n}\r\n\r\n.bw-popup-demo__tab {\r\n  background: transparent;\r\n  border-color: rgba(130, 177, 148, .34);\r\n}\r\n\r\n.bw-popup-demo__tab.is-active,\r\n.bw-popup-demo__tab:hover,\r\n.bw-popup-demo__back:hover {\r\n  background: rgba(130, 177, 148, .12);\r\n  border-color: rgba(130, 177, 148, .44);\r\n}\r\n\r\n.bw-popup-demo__tabs {\r\n  display: flex;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.bw-popup-demo__stage {\r\n  width: min(100%, 1160px);\r\n  min-height: 720px;\r\n  margin: 0 auto;\r\n  position: relative;\r\n  overflow: hidden;\r\n  border-radius: 32px;\r\n  background: var(--bw-bg, #EFF0EC);\r\n  border: 1px solid rgba(12, 36, 28, .08);\r\n  box-shadow: var(--bw-shadow-card, 0 10px 30px rgba(0, 0, 0, .03));\r\n}\r\n\r\n.bw-popup-demo__fake-page {\r\n  display: none;\r\n}\r\n\r\n.bw-popup-demo__fake-card {\r\n  min-height: 260px;\r\n  border-radius: var(--bw-card-radius, 24px);\r\n  background: rgba(247, 245, 241, .88);\r\n  border: 1px solid rgba(12, 36, 28, .08);\r\n}\r\n\r\n.bw-popup-demo__fake-main {\r\n  display: grid;\r\n  gap: 18px;\r\n  align-content: start;\r\n}\r\n\r\n.bw-popup-demo__fake-banner {\r\n  height: 320px;\r\n}\r\n\r\n.bw-popup-demo__fake-profile {\r\n  height: 170px;\r\n}\r\n\r\n.bw-popup-demo__fake-side {\r\n  height: 600px;\r\n}\r\n\r\n.bw-modal-backdrop {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 24px;\r\n  background: var(--bw-pay-backdrop, rgba(19, 35, 29, .44));\r\n  backdrop-filter: blur(4px);\r\n  -webkit-backdrop-filter: blur(4px);\r\n  z-index: 4;\r\n  animation: bw-backdrop-in .24s ease;\r\n}\r\n\r\n.bw-modal-backdrop.is-soft {\r\n  background: var(--bw-pay-backdrop-soft, rgba(19, 35, 29, .34));\r\n  backdrop-filter: blur(2px);\r\n  -webkit-backdrop-filter: blur(2px);\r\n}\r\n\r\n@keyframes bw-backdrop-in {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.bw-modal-card {\r\n  width: min(100%, var(--bw-pay-modal-width));\r\n  background: var(--bw-card-surface, #F7F5F1);\r\n  border: 1px solid var(--bw-surface-card-border, rgba(12, 36, 28, .08));\r\n  border-radius: var(--bw-card-radius, 24px);\r\n  box-shadow: 0 22px 48px rgba(18, 34, 28, .14), 0 2px 10px rgba(18, 34, 28, .06);\r\n  color: var(--bw-text-primary, #13231D);\r\n  animation: bw-modal-in .28s ease;\r\n}\r\n\r\n.bw-modal-card--center {\r\n  width: 100%;\r\n  text-align: center;\r\n  padding: 32px;\r\n}\r\n\r\n.bw-modal-card--status {\r\n  text-align: center;\r\n  padding: 32px;\r\n}\r\n\r\n.bw-modal-card--confirmation .bw-status-icon {\r\n  width: 80px;\r\n  height: 80px;\r\n  border: none;\r\n  background: none;\r\n}\r\n\r\n.bw-modal-card--confirmation .bw-status-icon svg {\r\n  width: 80px !important;\r\n  height: 80px !important;\r\n}\r\n\r\n@keyframes bw-modal-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(.94) translateY(12px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1) translateY(0);\r\n  }\r\n}\r\n\r\n.bw-status-icon {\r\n  width: 70px;\r\n  height: 70px;\r\n  margin: 0 auto 20px;\r\n  display: grid;\r\n  place-items: center;\r\n  color: var(--bw-primary-active, #5C826C);\r\n}\r\n\r\n.bw-status-icon svg {\r\n  width: 70px !important;\r\n  height: 70px !important;\r\n}\r\n\r\n.bw-status-icon--success {\r\n  width: 80px;\r\n  height: 80px;\r\n  border: none;\r\n  background: none;\r\n  color: var(--bw-primary-active, #5C826C);\r\n}\r\n\r\n.bw-status-icon--success svg {\r\n  width: 80px !important;\r\n  height: 80px !important;\r\n  fill: none;\r\n}\r\n\r\n.bw-status-icon--error {\r\n  color: #DC2626;\r\n}\r\n\r\n.bw-status-icon--error svg {\r\n  background-color: #FEE2E2;\r\n  border: 5px solid #DC2626;\r\n  border-radius: 50%;\r\n}\r\n\r\n.bw-status-icon--warning {\r\n  color: var(--bw-gold-strong, #B88928);\r\n}\r\n\r\n.bw-status-icon--info {\r\n  color: #598FD9;\r\n}\r\n\r\n.bw-status-icon--neutral {\r\n  color: #64748b;\r\n}\r\n\r\n\r\n.bw-modal-eyebrow {\r\n  margin: 0 0 8px;\r\n  font-size: 12px;\r\n  line-height: 1.2;\r\n  letter-spacing: .14em;\r\n  text-transform: uppercase;\r\n  font-weight: 800;\r\n  color: var(--bw-primary-active, #5C826C);\r\n}\r\n\r\n.bw-modal-title {\r\n  margin: 0;\r\n  font-size: 32px;\r\n  line-height: 1.04;\r\n  letter-spacing: -.045em;\r\n  font-weight: 800;\r\n  color: var(--bw-text-primary, #13231D);\r\n}\r\n\r\n.bw-modal-copy {\r\n  margin: 12px auto 0;\r\n  max-width: 38ch;\r\n  font-size: 15px;\r\n  line-height: 1.65;\r\n  color: var(--bw-text-secondary, rgba(19, 35, 29, .68));\r\n}\r\n\r\n.bw-modal-actions {\r\n  margin-top: 24px;\r\n  display: grid;\r\n  gap: 12px;\r\n}\r\n\r\n.bw-btn {\r\n  appearance: none;\r\n  min-height: 48px;\r\n  padding: 0 20px;\r\n  border-radius: var(--bw-control-radius, 16px);\r\n  border: 1px solid transparent;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  font-family: inherit;\r\n  font-size: 14px;\r\n  line-height: 1;\r\n  font-weight: 800;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  transition: background-color .2s ease, border-color .2s ease, transform .2s ease, box-shadow .2s ease;\r\n}\r\n\r\n.bw-btn:hover {\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.bw-btn-primary {\r\n  background: var(--bw-primary, #82B194);\r\n  border-color: var(--bw-primary, #82B194);\r\n  color: #fff;\r\n  box-shadow: 0 12px 24px rgba(130, 177, 148, .22);\r\n}\r\n\r\n.bw-btn-primary:hover {\r\n  background: var(--bw-primary-hover, #739F84);\r\n  border-color: var(--bw-primary-hover, #739F84);\r\n}\r\n\r\n.bw-btn-secondary {\r\n  background: transparent;\r\n  border-color: rgba(130, 177, 148, .48);\r\n  color: var(--bw-text-primary, #13231D);\r\n}\r\n\r\n.bw-btn-secondary:hover {\r\n  background: rgba(130, 177, 148, .10);\r\n}\r\n\r\n.bw-btn-quiet {\r\n  background: transparent;\r\n  border-color: rgba(16, 25, 21, .10);\r\n  color: var(--bw-text-secondary, rgba(19, 35, 29, .68));\r\n}\r\n\r\n.bw-btn-full {\r\n  width: 100%;\r\n}\r\n\r\n.bw-payment-header {\r\n  min-height: 72px;\r\n  padding: 20px 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  border-bottom: 1px solid rgba(12, 36, 28, .08);\r\n}\r\n\r\n.bw-payment-header__title {\r\n  margin: 0;\r\n  font-size: 22px;\r\n  line-height: 1.15;\r\n  letter-spacing: -.035em;\r\n  font-weight: 800;\r\n}\r\n\r\n.bw-payment-header__copy {\r\n  margin: 4px 0 0;\r\n  font-size: 13px;\r\n  line-height: 1.45;\r\n  color: var(--bw-text-secondary, rgba(19, 35, 29, .68));\r\n}\r\n\r\n.bw-payment-close {\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: var(--bw-radius-sm, 14px);\r\n  border: 1px solid rgba(16, 25, 21, .10);\r\n  background: transparent;\r\n  color: rgba(19, 35, 29, .58);\r\n  display: grid;\r\n  place-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.bw-payment-close:hover {\r\n  background: rgba(130, 177, 148, .10);\r\n  color: var(--bw-text-primary, #13231D);\r\n}\r\n\r\n.bw-payment-body {\r\n  padding: 26px;\r\n  display: grid;\r\n  grid-template-columns: 60% 40%;\r\n  gap: 24px;\r\n  align-items: start;\r\n}\r\n\r\n.bw-payment-provider-shell {\r\n  min-height: 352px;\r\n  padding: 22px;\r\n  border-radius: var(--bw-radius-xl, 24px);\r\n  background: var(--bw-input-surface, #FFFFFF);\r\n  border: 1px solid rgba(16, 25, 21, .08);\r\n  box-shadow: 0 10px 26px rgba(18, 34, 28, .05);\r\n}\r\n\r\n.bw-payment-iframe {\r\n  width: 100%;\r\n  min-height: 348px;\r\n  border: 0;\r\n  display: block;\r\n  border-radius: var(--bw-radius-lg, 18px);\r\n  background: #fff;\r\n}\r\n\r\n.bw-payment-summary {\r\n  padding: 18px;\r\n  border-radius: var(--bw-radius-xl, 24px);\r\n  background: var(--bw-card-surface-soft, #F8F6F2);\r\n  border: 1px solid rgba(12, 36, 28, .08);\r\n}\r\n\r\n.bw-payment-summary h3 {\r\n  margin: 0 0 14px;\r\n  font-size: 16px;\r\n  line-height: 1.2;\r\n  letter-spacing: -.02em;\r\n}\r\n\r\n.bw-payment-summary dl {\r\n  margin: 0;\r\n  display: grid;\r\n  gap: 10px;\r\n}\r\n\r\n.bw-payment-summary__row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding-bottom: 10px;\r\n  border-bottom: 1px solid rgba(16, 25, 21, .08);\r\n}\r\n\r\n.bw-payment-summary__row:last-child {\r\n  padding-bottom: 0;\r\n  border-bottom: 0;\r\n}\r\n\r\n.bw-payment-summary dt,\r\n.bw-payment-summary dd {\r\n  margin: 0;\r\n  font-size: 12px;\r\n  line-height: 1.45;\r\n}\r\n\r\n.bw-payment-summary dt {\r\n  color: var(--bw-text-secondary, rgba(19, 35, 29, .68));\r\n  font-weight: 600;\r\n}\r\n\r\n.bw-payment-summary dd {\r\n  text-align: right;\r\n  color: var(--bw-text-primary, #13231D);\r\n  font-weight: 800;\r\n}\r\n\r\n.bw-payment-secure {\r\n  margin-top: 14px;\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: flex-start;\r\n  font-size: 12px;\r\n  line-height: 1.45;\r\n  color: var(--bw-text-secondary, rgba(19, 35, 29, .68));\r\n}\r\n\r\n.bw-payment-secure svg {\r\n  width: 16px;\r\n  height: 16px;\r\n  flex: 0 0 auto;\r\n  stroke: var(--bw-primary-active, #5C826C);\r\n  fill: none;\r\n  stroke-width: 2;\r\n}\r\n\r\n/* Simulación visual de una pasarela externa. En producción se reemplaza por iframe o SDK. */\r\n.provider-demo {\r\n  width: min(100%, 520px);\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  color: #1f2937;\r\n}\r\n\r\n.provider-demo__label {\r\n  margin: 0 0 12px;\r\n  font-size: 13px;\r\n  line-height: 1.2;\r\n  font-weight: 700;\r\n}\r\n\r\n.provider-demo__input {\r\n  width: 100%;\r\n  min-height: 42px;\r\n  padding: 0 14px;\r\n  margin-bottom: 12px;\r\n  border-radius: 8px;\r\n  border: 1px solid #d1d5db;\r\n  background: #fff;\r\n  color: #6b7280;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  font-size: 14px;\r\n}\r\n\r\n.provider-demo__grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 10px;\r\n}\r\n\r\n.provider-demo__button {\r\n  margin-top: 18px;\r\n  width: 100%;\r\n  min-height: 46px;\r\n  border: 0;\r\n  border-radius: 8px;\r\n  background: #2563eb;\r\n  color: #fff;\r\n  font-size: 13px;\r\n  font-weight: 800;\r\n  letter-spacing: .08em;\r\n  text-transform: uppercase;\r\n  display: grid;\r\n  place-items: center;\r\n  box-shadow: 0 8px 18px rgba(37, 99, 235, .24);\r\n}\r\n\r\n.bw-toast {\r\n  position: absolute;\r\n  left: 24px;\r\n  bottom: 22px;\r\n  width: min(520px, calc(100% - 48px));\r\n  display: flex;\r\n  gap: 14px;\r\n  align-items: flex-start;\r\n  padding: 16px 18px;\r\n  border-radius: var(--bw-radius-lg, 18px);\r\n  background: var(--bw-card-surface, #F7F5F1);\r\n  border: 1px solid rgba(130, 177, 148, .28);\r\n  box-shadow: 0 18px 34px rgba(18, 34, 28, .12);\r\n  z-index: 7;\r\n}\r\n\r\n.bw-message {\n  position: fixed;\r\n  bottom: 22px;\r\n  left: 24px;\r\n  max-width: 520px;\r\n  display: flex;\r\n  gap: 14px;\r\n  align-items: flex-start;\r\n  padding: 16px 18px;\r\n  border-radius: var(--bw-radius-lg, 12px);\r\n  background: #ffffff;\r\n  border: 1px solid rgba(0, 0, 0, 0.06);\r\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.08);\r\n  z-index: 1400;\r\n}\r\n\r\n.bw-message__icon {\r\n  width: 30px;\r\n  height: 30px;\r\n  flex: 0 0 30px;\r\n  display: inline-grid;\r\n  place-items: center;\r\n  background: rgba(130, 177, 148, .18);\r\n  color: var(--bw-primary-active, #5C826C);\r\n  border-radius: var(--bw-radius-pill, 999px);\r\n  border: 1px solid rgba(130, 177, 148, .14);\r\n}\r\n\r\n.bw-message__content {\r\n  display: block;\r\n  min-width: 0;\r\n  padding-top: 1px\r\n}\r\n\r\n.bw-message__title {\r\n  display: block;\r\n  font-size: 14px;\r\n  line-height: 1.25;\r\n  color: var(--bw-text-primary, #13231D);\r\n}\r\n\r\n.bw-message__message {\r\n  display: block;\r\n  margin-top: 6px;\r\n  font-size: 13px;\r\n  line-height: 1.45;\r\n  color: var(--bw-text-secondary, rgba(19, 35, 29, .68));\r\n}\r\n\r\n.bw-message__close {\r\n  margin-left: auto;\r\n  width: 24px;\r\n  height: 24px;\r\n  border: 0;\r\n  background: transparent;\r\n  color: rgba(19, 35, 29, .46);\r\n  cursor: pointer;\r\n  display: grid;\r\n  place-items: center;\r\n  padding: 0\r\n}\r\n\r\n.bw-toast__icon {\r\n  width: 30px;\r\n  height: 30px;\r\n  flex: 0 0 30px;\r\n  margin-top: 0;\r\n  border-radius: var(--bw-radius-pill, 999px);\r\n  display: inline-grid;\r\n  place-items: center;\r\n  background: rgba(130, 177, 148, .18);\r\n  color: var(--bw-primary-active, #5C826C);\r\n}\r\n\r\n.bw-toast__icon svg {\r\n  display: block;\r\n  width: 17px;\r\n  height: 17px;\r\n  stroke: currentColor;\r\n  fill: none;\r\n  stroke-width: 2.3;\r\n  stroke-linecap: round;\r\n  stroke-linejoin: round;\r\n}\r\n\r\n.bw-toast__content {\r\n  display: block;\r\n  min-width: 0;\r\n  padding-top: 1px;\r\n}\r\n\r\n.bw-toast strong,\r\n.bw-toast__title {\r\n  display: block;\r\n  font-size: 14px;\r\n  line-height: 1.25;\r\n  color: var(--bw-text-primary, #13231D);\r\n}\r\n\r\n.bw-toast__message {\r\n  display: block;\r\n  margin-top: 3px;\r\n  font-size: 13px;\r\n  line-height: 1.45;\r\n  color: var(--bw-text-secondary, rgba(19, 35, 29, .68));\r\n}\r\n\r\n.bw-toast__title {\r\n  display: block;\r\n  border: 1px solid rgba(130, 177, 148, .14);\r\n  line-height: 1.25;\r\n  color: var(--bw-text-primary, #13231D);\r\n  font-weight: 700\r\n}\r\n\r\n.bw-toast__close {\r\n  margin-left: auto;\r\n  width: 24px;\r\n  height: 24px;\r\n  border: 0;\r\n  background: transparent;\r\n  color: rgba(19, 35, 29, .46);\r\n  cursor: pointer;\r\n  display: grid;\r\n  place-items: center;\r\n  padding: 0;\r\n}\r\n\r\n.bw-popup-state {\r\n  display: none;\r\n}\r\n\r\n.bw-popup-state.is-active {\r\n  display: block;\r\n}\r\n\r\n@media (max-width:900px) {\r\n  .bw-popup-demo__stage {\r\n    min-height: 760px;\r\n  }\r\n\r\n  .bw-popup-demo__fake-page {\r\n    grid-template-columns: 1fr;\r\n    padding: 24px;\r\n  }\r\n\r\n  .bw-popup-demo__fake-side {\r\n    display: none;\r\n  }\r\n\r\n  .bw-payment-body {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .bw-payment-summary {\r\n    order: -1;\r\n  }\r\n\r\n  .bw-modal-card--wide {\r\n    max-height: calc(100vh - 48px);\r\n    max-height: calc(100dvh - 48px);\r\n    overflow-y: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n}\r\n\r\n@media (max-width:620px) {\r\n  .bw-popup-demo {\r\n    padding: 20px 14px 56px;\r\n  }\r\n\r\n  .bw-popup-demo__stage {\r\n    border-radius: 24px;\r\n    min-height: 760px;\r\n  }\r\n\r\n  .bw-modal-backdrop {\r\n    padding: 16px;\r\n    align-items: center;\r\n  }\r\n\r\n  .bw-modal-card {\r\n    padding: 24px 20px;\r\n    border-radius: 22px;\r\n  }\r\n\r\n  .bw-modal-card--wide {\r\n    padding: 0;\r\n    max-height: calc(100vh - 32px);\r\n    max-height: calc(100dvh - 32px);\r\n    border-radius: 18px;\r\n  }\r\n\r\n  .bw-modal-title {\r\n    font-size: 28px;\r\n  }\r\n\r\n  .bw-payment-body {\r\n    padding: 18px;\r\n    gap: 16px;\r\n  }\r\n\r\n  .bw-payment-header {\r\n    padding: 18px;\r\n  }\r\n\r\n  .bw-payment-provider-shell {\r\n    padding: 16px;\r\n  }\r\n\r\n  .bw-payment-iframe {\r\n    min-height: 400px;\r\n  }\r\n\r\n  .bw-toast {\r\n    left: 16px;\r\n    bottom: 16px;\r\n    width: calc(100% - 32px);\r\n  }\r\n\r\n  .provider-demo__grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n/* =========================================================\r\n   Estado adicional — Datos de reserva antes del pago\r\n   Reemplaza la acción positiva roja por Primary Bodhiwell y\r\n   ordena la información en header / cuerpo / footer.\r\n========================================================= */\r\n\r\n.bw-modal-card--booking {\r\n  width: min(100%, 960px);\r\n  max-height: min(90vh, 90dvh);\r\n  padding: 0;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.bw-booking-header {\r\n  padding: 24px 32px 16px;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n  border-bottom: 1px solid rgba(12, 36, 28, .08);\r\n}\r\n\r\n.bw-booking-title {\r\n  margin: 0;\r\n  font-size: 26px;\r\n  line-height: 1.12;\r\n  letter-spacing: -.04em;\r\n  font-weight: 800;\r\n  color: var(--bw-text-primary, #13231D);\r\n}\r\n\r\n.bw-booking-copy {\r\n  margin: 8px 0 0;\r\n  max-width: none;\r\n  font-size: 13px;\r\n  line-height: 1.45;\r\n  color: var(--bw-text-secondary, rgba(19, 35, 29, .68));\r\n}\r\n\r\n.bw-booking-body {\r\n  padding: 20px 32px 18px;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 28px;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n.bw-booking-panel {\r\n  display: grid;\r\n  align-content: start;\r\n  gap: 18px;\r\n}\r\n\r\n.bw-field {\r\n  display: grid;\r\n  gap: 8px;\r\n}\r\n\r\n.bw-field span,\r\n.bw-upload-label {\r\n  font-size: 13px;\r\n  line-height: 1.35;\r\n  font-weight: 600;\r\n  color: var(--bw-text-primary, #13231D);\r\n}\r\n\r\n.bw-field input,\r\n.bw-field textarea {\r\n  width: 100%;\r\n  border: 1px solid rgba(16, 25, 21, .14);\r\n  border-radius: var(--bw-control-radius, 16px);\r\n  background: var(--bw-input-surface, #FFFFFF);\r\n  color: var(--bw-text-primary, #13231D);\r\n  font-family: inherit;\r\n  font-size: 15px;\r\n  line-height: 1.45;\r\n  outline: none;\r\n  transition: border-color .2s ease, box-shadow .2s ease;\r\n}\r\n\r\n.bw-field input {\r\n  min-height: 50px;\r\n  padding: 0 16px;\r\n}\r\n\r\n.bw-field textarea {\r\n  min-height: 118px;\r\n  padding: 14px 16px;\r\n  resize: vertical;\r\n}\r\n\r\n.bw-field input::placeholder,\r\n.bw-field textarea::placeholder {\r\n  color: rgba(19, 35, 29, .36);\r\n}\r\n\r\n.bw-field input:focus,\r\n.bw-field textarea:focus {\r\n  border-color: rgba(130, 177, 148, .70);\r\n  box-shadow: 0 0 0 4px rgba(130, 177, 148, .14);\r\n}\r\n\r\n.bw-booking-note {\r\n  margin-top: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  min-height: 46px;\r\n  padding: 10px 14px;\r\n  border-radius: var(--bw-control-radius, 16px);\r\n  background: rgba(130, 177, 148, .12);\r\n  color: var(--bw-primary-active, #5C826C);\r\n  font-size: 13px;\r\n  line-height: 1.45;\r\n}\r\n\r\n.bw-booking-note svg {\r\n  width: 18px;\r\n  height: 18px;\r\n  flex: 0 0 auto;\r\n  fill: none;\r\n  stroke: currentColor;\r\n  stroke-width: 1.8;\r\n  stroke-linecap: round;\r\n  stroke-linejoin: round;\r\n}\r\n\r\n.bw-booking-note strong {\r\n  font-weight: 800;\r\n}\r\n\r\n.bw-upload-card {\r\n  width: 100%;\r\n  min-height: 148px;\r\n  border-radius: var(--bw-radius-xl, 24px);\r\n  border: 1.5px dashed rgba(92, 130, 108, .38);\r\n  background: var(--bw-card-surface-soft, #F8F6F2);\r\n  color: var(--bw-text-primary, #13231D);\r\n  font-family: inherit;\r\n  display: grid;\r\n  place-items: center;\r\n  align-content: center;\r\n  gap: 10px;\r\n  padding: 24px;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  transition: background-color .2s ease, border-color .2s ease, transform .2s ease;\r\n}\r\n\r\n.bw-upload-card:hover {\r\n  background: rgba(130, 177, 148, .10);\r\n  border-color: rgba(92, 130, 108, .62);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.bw-upload-card__icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: var(--bw-radius-pill, 999px);\r\n  display: grid;\r\n  place-items: center;\r\n  background: rgba(130, 177, 148, .16);\r\n  color: var(--bw-primary-active, #5C826C);\r\n}\r\n\r\n.bw-upload-card__icon svg {\r\n  width: 20px;\r\n  height: 20px;\r\n  fill: none;\r\n  stroke: currentColor;\r\n  stroke-width: 1.9;\r\n  stroke-linecap: round;\r\n  stroke-linejoin: round;\r\n}\r\n\r\n.bw-upload-card strong {\r\n  color: var(--bw-primary-active, #5C826C);\r\n  font-weight: 800;\r\n}\r\n\r\n.bw-upload-card small {\r\n  font-size: 12px;\r\n  line-height: 1.3;\r\n  color: var(--bw-text-secondary, rgba(19, 35, 29, .68));\r\n}\r\n\r\n.bw-booking-footer {\r\n  padding: 18px 32px 26px;\r\n  display: grid;\r\n  grid-template-columns: auto minmax(0, 1fr) auto;\r\n  align-items: center;\r\n  gap: 22px;\r\n  border-top: 1px solid rgba(12, 36, 28, .08);\r\n}\r\n\r\n.bw-booking-price {\r\n  min-width: 136px;\r\n  min-height: 58px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 10px 16px;\r\n  border-radius: var(--bw-control-radius, 16px);\r\n  background: rgba(130, 177, 148, .12);\r\n  color: var(--bw-text-primary, #13231D);\r\n}\r\n\r\n.bw-booking-price__icon {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: var(--bw-radius-pill, 999px);\r\n  display: grid;\r\n  place-items: center;\r\n  background: rgba(130, 177, 148, .22);\r\n  color: var(--bw-primary-active, #5C826C);\r\n  font-weight: 800;\r\n}\r\n\r\n.bw-booking-price small {\r\n  display: block;\r\n  margin-bottom: 2px;\r\n  font-size: 11px;\r\n  line-height: 1;\r\n  letter-spacing: .08em;\r\n  text-transform: uppercase;\r\n  color: var(--bw-text-secondary, rgba(19, 35, 29, .68));\r\n  font-weight: 800;\r\n}\r\n\r\n.bw-booking-price strong {\r\n  display: block;\r\n  font-size: 18px;\r\n  line-height: 1.1;\r\n  letter-spacing: -.02em;\r\n}\r\n\r\n.bw-switch-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  gap: 12px;\r\n  font-size: 14px;\r\n  line-height: 1.35;\r\n  color: var(--bw-text-primary, #13231D);\r\n  cursor: pointer;\r\n}\r\n\r\n.bw-switch-row input {\r\n  position: absolute;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n.bw-switch {\r\n  width: 42px;\r\n  height: 24px;\r\n  border-radius: var(--bw-radius-pill, 999px);\r\n  background: rgba(19, 35, 29, .20);\r\n  position: relative;\r\n  flex: 0 0 auto;\r\n  transition: background-color .2s ease;\r\n}\r\n\r\n.bw-switch::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 3px;\r\n  left: 3px;\r\n  width: 18px;\r\n  height: 18px;\r\n  border-radius: 50%;\r\n  background: #fff;\r\n  box-shadow: 0 2px 6px rgba(18, 34, 28, .18);\r\n  transition: transform .2s ease;\r\n}\r\n\r\n.bw-switch-row input:checked+.bw-switch {\r\n  background: var(--bw-primary, #82B194);\r\n}\r\n\r\n.bw-switch-row input:checked+.bw-switch::after {\r\n  transform: translateX(18px);\r\n}\r\n\r\n.bw-booking-cta {\r\n  min-width: 220px;\r\n}\r\n\r\n@media (max-width:900px) {\r\n  .bw-modal-card--booking {\r\n    max-height: none;\r\n    height: auto;\r\n    overflow: visible;\r\n  }\r\n\r\n  .bw-booking-body {\r\n    grid-template-columns: 1fr;\r\n    gap: 20px;\r\n  }\r\n\r\n  .bw-booking-footer {\r\n    grid-template-columns: 1fr;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .bw-booking-cta {\r\n    width: 100%;\r\n    min-width: 0;\r\n  }\r\n}\r\n\r\n@media (max-width:620px) {\r\n  .bw-booking-header {\r\n    padding: 22px 20px 18px;\r\n  }\r\n\r\n  .bw-booking-title {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .bw-booking-body {\r\n    padding: 20px;\r\n  }\r\n\r\n  .bw-booking-footer {\r\n    padding: 18px 20px 22px;\r\n  }\r\n}\r\n\r\n\r\n/* Fix autofill blue background */\r\n.bw-field input:-webkit-autofill,\r\n.bw-field input:-webkit-autofill:hover,\r\n.bw-field input:-webkit-autofill:focus,\r\n.bw-field input:-webkit-autofill:active {\r\n  -webkit-box-shadow: 0 0 0 30px #FFFFFF inset !important;\r\n  -webkit-text-fill-color: var(--bw-text-primary, #13231D) !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
